import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CamionesPenalizados {
  static getPenalizacionCamion (camion) {
    const axios = getAxiosInstance()
    const promise = axios.get(`penalizacion_de_transporte_camion_listado?r=` +
        `{"clave":{"camion": "${camion}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getPenalizacionAcoplado (acoplado) {
    const axios = getAxiosInstance()
    const promise = axios.get(`penalizacion_de_transporte_acoplado_listado?r=` +
      `{"clave":{"acoplado": "${acoplado}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getPenalizacionPorPatente (patente) {
    const axios = getAxiosInstance()
    const promise = axios.get(`penalizacion_vigente_transporte_terrestre_por_patente?r=` +
      `{"clave":{"patente": "${patente}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getPenalizadosVigentes (patente, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`penalizacion_vigente_transporte_terrestre?r=` +
      `{"clave":{"patente": "${patente}", "cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static deletePenalizacionVigente (patente, vencimiento) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`penalizacion_vigente_transporte_terrestre?r=` +
      `{"clave":{"patente": "${patente}", "fecha_vencimiento": "${vencimiento}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static deletePenalizacionCamion (camion, fechaPenalizacion) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`penalizacion_de_camion?r=` +
      `{"clave":{"camion": "${camion}", "fecha_penalizacion": "${fechaPenalizacion}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static deletePenalizacionAcoplado (acoplado, fechaPenalizacion) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`penalizacion_de_acoplado?r=` +
      `{"clave":{"acoplado": "${acoplado}", "fecha_penalizacion": "${fechaPenalizacion}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static insertPenalizacionCamion (fechaPenalizacion, patente, vencimiento, motivo) {
    const axios = getAxiosInstance()
    const promise = axios.post(`penalizacion_de_transporte_camion`, `{"valores": {"fecha_penalizacion": "${fechaPenalizacion}", "fecha_vencimiento":"${vencimiento}", "camion": "${patente}", "motivo": "${motivo}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static insertPenalizacionAcoplado (fechaPenalizacion, patente, vencimiento, motivo) {
    const axios = getAxiosInstance()
    const promise = axios.post(`penalizacion_de_transporte_acoplado`, `{"valores": {"fecha_penalizacion": "${fechaPenalizacion}", "fecha_vencimiento":"${vencimiento}", "acoplado": "${patente}", "motivo": "${motivo}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }
}

export default CamionesPenalizados
